<template>
<el-drawer title="查看" size="100%" :visible.sync="drawerVisible" :append-to-body="true" :center="true" :wrapperClosable="false" :withHeader="false">
    <div style="padding:10px 0;">
        <order-detail :order="order" :wedding="wedding"></order-detail>
    </div>
    <div class="box">
        <div class="box-center">
            <div class="fixed-btns">
                <el-button type="primary" class="closeBtn" @click="closeDrawer">关闭</el-button>
                <div>
                    <el-button type="primary" @click="save" v-if="demand.item_check_status1!=2">预备派单</el-button>
                    <el-button type="danger" v-preventReClick @click="submit">总控工程提交并审核</el-button>
                </div>

            </div>
            <el-form ref="form" :model="ruleForm" label-width="80px">
                <div class="selected-list">
                    <template v-for="item in tree">
                        <div class="selected-item" :key="item.id">
                            <div class="tree-title">
                                <span class="title-name mr8">{{item.title}}</span>
                                <!-- <el-select v-model="ruleForm.supplier_id">
                                        <el-option v-for="(supplier,sk) in item.supplier" placeholder="请选择供应商" :key="sk" :label="supplier.title" :value="supplier.id"></el-option>
                                    </el-select>
                                    <el-button style="margin-left:10px;" type="primary" @click="setSupplier(item.children, item.supplier)">分配</el-button> -->
                            </div>
                            <div class="children">
                                <template v-for="child in item.children">
                                    <div class="category-item" :key="child.id" v-if="forms['category_'+child.id]">
                                        <div class=" category-title">
                                            {{child.title}}
                                        </div>
                                        <div class="category-rules">
                                            <div class="select-item-list">
                                                <div class="hs-table-pro">
                                                    <div class="hs-table-row  hs-table-header">
                                                        <div class="hs-table-col">供应商</div>
                                                        <div class="hs-table-col">产品</div>
                                                        <div class="hs-table-col">价格</div>
                                                        <div class="hs-table-col" v-for="(e,v) in child.rules" :key="v">
                                                            {{e.label}}
                                                        </div>
                                                        <div class="hs-table-col">数量</div>
                                                        <div class="hs-table-col">自定义价格</div>
                                                        <div class="hs-table-col">使用备注</div>
                                                        <div class="hs-table-col">是否作废</div>
                                                        <div class="hs-table-col w120">操作</div>
                                                    </div>
                                                    <div class="hs-table-row" v-for="(row,index) in forms['category_'+child.id]" :key="index">
                                                        <div class="hs-table-col">
                                                            {{row.supplier ? row.supplier.title : '未分配'}}
                                                        </div>
                                                        <div class="hs-table-col">
                                                            {{row.product ? row.product.title : '未分配'}}
                                                        </div>
                                                        <div class="hs-table-col">
                                                            {{row.product ? row.product.price : '未分配'}}
                                                        </div>
                                                        <template v-for="(e, f) in row">
                                                            <div class="hs-table-col" :key="f" v-if="f!='invalid' &&f!='invalid_id' && f!='settle_no' &&f!='count'&& f!='settle' && f!='remark'&& f!='supplier'&& f!='price' && f!='product'&&f!='product_id' && f!='supplier_id'">
                                                                <span>{{former.getRuleLabel(e,f,child.rules)}}</span>
                                                            </div>
                                                        </template>
                                                        <div class="hs-table-col">{{row.count}}</div>
                                                        <div class="hs-table-col">{{row.price}}</div>
                                                        <div class="hs-table-col">{{row.remark}}</div>
                                                        <div class="hs-table-col">
                                                            <template v-if="row.invalid_id=='0'">已作废</template>
                                                            <template v-if="row.invalid_id=='1'"></template>
                                                        </div>
                                                        <div class="hs-table-col" v-if="type=='editors'">
                                                            <el-link v-if="!row.settle || row.settle==3" type="warning" class="mr8" @click="showDrawerPass(_self, 'editorView', 'showProject', [row])">临时编辑</el-link>
                                                            <el-link v-else>{{getSettleText(row.settle)}}</el-link>
                                                        </div>
                                                        <div class="hs-table-col w120" v-else>
                                                            <el-link type="primary" class="mr8" @click="showDrawerPass(_self, 'supplierView', 'showDialog', [row,child.title])">编辑</el-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                            </div>
                        </div>

                    </template>
                    <supplier-view ref="supplierView" :parent="_self"></supplier-view>
                    <editor-view ref="editorView" :parent="_self"></editor-view>
                </div>
            </el-form>
        </div>
    </div>
</el-drawer>
</template>

<script>
const ruleForm = {
    type: "project",
    supplier_id: "",
    order_id: ""
};
import {
    showDrawerPass,
} from '@/utils/common.js';
import former from '@/utils/former.js';
import weddingUtils from '@/utils/wedding.js';
import supplierView from './supplier.vue';
// 订单信息
import orderDetail from '../orderDetails/detail';
import editorView from '@/components/editor/editor.vue';
import {
    preventReClick
} from '@/utils/preventReClick';
export default {
    components: {
        supplierView,
        orderDetail,
        editorView

    },
    props: {
        parent: {}
    },
    data() {
        return {
            drawerVisible: false,
            ruleForm: Object.assign({}, ruleForm),
            category: [],
            activeNames: ['1'],
            categoryType: [],
            parent_id: 0,

            tree: {},
            selected: [],
            forms: {},
            module: 'wedding_demand',
            module_id: 0,
            demand: {},
            id: '',
            order_id: '',
            order: {},
            wedding: {},
            type: ""
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.former = former;
        this.getRuleTag = weddingUtils.getRuleTag;
    },
    methods: {
        getSettleText(status) {
            if (status == 1) return "结算中";
            if (status == 2) return "结算通过";
            if (status == 3) return "结算驳回";
            return "待结算";
        },
        showDrawer(options, type) {
            let _this = this;
            _this.ruleForm.order_id = options;
            _this.order_id = options.order_id;
            _this.id = options.id;
            _this.drawerVisible = true;
            _this.type = type;

            let url = '/api/plan.demand/get';
            let params = {
                type: "project",
                order_id: options.order_id,
                id: options.id,
            };
            this.$post(url, params).then(res => {
                if (res.code == '200') {
                    _this.demand = res.data.demand
                    _this.forms = res.data.demand.addons;
                    _this.tree = res.data.tree;
                    _this.getOrderDetail(options.order_id)
                }
            })

        },
        showChange(options, type) {
            let _this = this;
            _this.ruleForm.order_id = options;
            _this.order_id = options.order_id;
            _this.id = options.id;
            _this.drawerVisible = true;
            _this.type = type;

            let url = '/api/plan.demand/get';
            let params = {
                type: "project",
                order_id: options.order_id,
                id: options.id,
            };
            this.$post(url, params).then(res => {
                if (res.code == '200') {
                    _this.demand = res.data.demand
                    _this.forms = res.data.demand.addons;
                    _this.tree = res.data.tree;
                    _this.getOrderDetail(options.order_id)
                }
            })

        },
        // 获取婚庆订单详情
        getOrderDetail(orderId) {
            let _this = this;
            let url = '/api/plan.order/detail';
            this.$post(url, {
                order_id: orderId
            }).then(function (res) {
                if (res.code == '200') {
                    _this.order = res.data.order;
                    _this.wedding = res.data.wedding;
                }
            });
        },
        addAttr(id) {
            let field = "category_" + id;
            let row = Object.assign({}, this.ruleForm[field]);
            this.forms[field].push(row);
            this.$forceUpdate();
        },
        setSupplier(children, suppliers) {
            if (!this.ruleForm.supplier_id) return false;
            let target = suppliers.find(ele => ele.id == this.ruleForm.supplier_id);
            let status = {
                "status": 1,
                'stitle': '已分配',
            }
            target = Object.assign(target, status);
            let _this = this;
            if (!target) return false;
            children.forEach(ele => {
                let id = 'category_' + ele.id;
                if (_this.forms[id]) {
                    _this.forms[id].forEach(row => {
                        if (row['supplier'] == []) {
                            row['supplier'] = target;
                        } else {
                            row['supplier'] = target;
                        }
                    })
                }
            });
            this.ruleForm.supplier_id = '';
            this.$forceUpdate();
        },
        //驳回
        reject(row) {
            this.$confirm('确定要驳回需求单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.supplier = {
                    "status": 2,
                    'stitle': '已驳回',
                    'title': '供应商未添写'
                };
                this.$forceUpdate();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //提交
        submit() {
            let _this = this;
            _this.$confirm('确定提交T台/桁架工程单, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (_this.type == "editors") {
                    let url = '/api/wedding.demand/update';
                    let options = _this.ruleForm;
                    options.addons = this.forms;
                    options.type = 'control_project';
                    options.order_id = _this.order_id;
                    options.id = _this.id;
                    this.$post(url, options).then(res => {
                        if (res.code == '200') {
                            _this.drawerVisible = false
                            _this.$message({
                                type: 'success',
                                message: res.msg
                            });
                            if (this.parent.getData) {
                                _this.parent.getData(options.order_id)
                            } else {
                                _this.parent.showDrawer(options)
                            }

                        } else {
                            _this.$message({
                                type: 'danger',
                                message: res.msg
                            })
                        }
                    });
                } else {
                    let url = '/api/wedding.demand/create';
                    let options = _this.ruleForm;
                    options.addons = this.forms;
                    options.type = 'control_project';
                    options.order_id = _this.order_id;
                    options.id = _this.id;
                    this.$post(url, options).then(res => {
                        if (res.code == '200') {
                            _this.drawerVisible = false
                            _this.$message({
                                type: 'success',
                                message: res.msg
                            });
                            if (this.parent.getData) {
                                _this.parent.getData(options.order_id)
                            } else {
                                _this.parent.showDrawer(options)
                            }
                        } else {
                            _this.$message({
                                type: 'danger',
                                message: res.msg
                            })
                        }
                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        //暂存
        save() {
            let _this = this;
            let url = '/api/wedding.demand/save';
            let options = _this.ruleForm;
            options.addons = this.forms;
            options.type = 'control_project';
            options.order_id = _this.order_id;
            options.id = _this.id;
            this.$post(url, options).then(res => {
                if (res.code == '200') {
                    _this.drawerVisible = false
                    _this.$message({
                        type: 'success',
                        message: res.msg
                    });
                    _this.parent.showDrawer(options)
                } else {
                    _this.$message({
                        type: 'danger',
                        message: res.msg
                    })
                }
            });
        },
        closeDrawer() {
            this.drawerVisible = false;
        }
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.attr-date,
.attr-select,
.attr-input,
.attr-remark {
    margin-right: 8px;
}

.attr-input,
.attr-select,
.attr-remark {
    width: 220px;
}

/************ 分割线 **************/
.box {
    display: flex;
    position: relative;
    height: 100vh;
    overflow: hidden;
    margin-top: 50px;

    .box-center {
        flex: 1;
        height: 100vh;
        overflow: auto;
        padding-bottom: 100px;
    }

    .box-comment {
        flex: 0 20%;
        height: 100vh;
        overflow: auto;
        padding: 12px;
        border-left: 1px solid #dedede;
    }
}

.fixed-btns {
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 2000;
    height: 55px;
    line-height: 55px;
    width: 100%;
    text-align: right;
    padding-right: 24px;
    background: #f6f7fb;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 55px;
    width: 100%;
    text-align: right;
    padding-right: 24px;
    background: #f6f7fb;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 10px;
    line-height: 35px;
}

.selected-list {
    padding-left: 12px;
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}

/*** --------------------------------------- 分界线 ------------------------ ***/
.form-header {
    display: flex;
    padding: 12px;
    border-bottom: 1px solid #dedede;

    .form-submit {
        flex: 1;
        text-align: right;
    }
}

.main-demand {
    display: flex;

    .form-demand {
        flex: 1;
        padding-bottom: 20px;
    }

    .more-demand {
        flex: 0 25%;
        padding: 12px;
        border-left: 1px solid #dedede;
    }
}

.hs-table-pro {
    .hs-table-row {
        display: flex;
        border-top: .5px solid #f6f7fb;

        .hs-table-col {
            flex: 1;
            padding: 5px 8px;
            border-right: .5px solid #f6f7fb;
        }

        .hs-table-col.w120 {
            flex: 0 120px;
        }
    }

    .hs-table-row.hs-table-header {
        background: #f6f7fb;
        border-top: none;
    }
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}
</style>
